module.exports = __webpack_public_path__ + "media/src/assets/images/amenities_blue/work_space-c3afe59d0a19bf297c945c1cccb5146a.svg";